<template>
  <div class="content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" :payroll="payroll" />
    </div>
    <div class="main-content">
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";

export default {
  name: "Payroll",
  components: {
    Header,
    Sidebar,
  },
  data() {
    return { item: "regular", payroll: "payroll" };
  },
  metaInfo: {
    title: 'HR Desk Payroll - Efficient and Accurate Payroll Processing',
    meta: [
      { name: 'description', content: 'Streamline your payroll processing with HR Desk. Ensure timely and accurate payroll management, employee satisfaction.' },
      { property: 'og:title', content: 'HR Desk Payroll - Efficient and Accurate Payroll Processing' },
      { property: 'og:description', content: 'Streamline your payroll processing with HR Desk. Ensure timely and accurate payroll management, employee satisfaction.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/payroll' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'HR Desk Payroll - Efficient and Accurate Payroll Processing' },
      { name: 'twitter:description', content: 'Streamline your payroll processing with HR Desk. Ensure timely and accurate payroll management, employee satisfaction.' },
      { name: 'twitter:image:alt', content: 'Payroll at hrdesk' },
      { name: 'keywords', content: 'payroll processing, HR payroll, payroll management, employee payroll' },
    ]
  }
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

   .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .main-content {
   margin-top: 2rem;
    background: #fbfafa;
    margin-left: 200px;
    height: 100vh;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .content {
      flex-direction: column;
    }
  }
}
</style>